var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Callouts } from "../../callouts/Callouts";
import { ContextMenuDOM } from "../../context-menu/ContextMenuDOM";
import { ContextMenuOutskirtsBuildingDOM } from "../../outskirts/ContextMenuOutskirtsBuildingDOM";
import { BF2HudPlayerBaseDOM } from "../../player-base/hud/BF2HudPlayerBaseDOM";
import { RewardPelletsDOM } from "../../reward-pellets/RewardPelletsDOM";
import { TooltipTextBuilding } from "../../tooltip/TooltipTextBuilding";
var BF2ScenePlayerBaseDOM = /** @class */ (function (_super) {
    __extends(BF2ScenePlayerBaseDOM, _super);
    function BF2ScenePlayerBaseDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BF2ScenePlayerBaseDOM.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Callouts, null),
            React.createElement(TooltipTextBuilding, null),
            React.createElement(ContextMenuDOM, null),
            React.createElement(ContextMenuOutskirtsBuildingDOM, null),
            React.createElement(BF2HudPlayerBaseDOM, null),
            React.createElement(RewardPelletsDOM, null)));
    };
    return BF2ScenePlayerBaseDOM;
}(React.Component));
export { BF2ScenePlayerBaseDOM };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/scenes/BF2ScenePlayerBaseDOM.tsx
// module id = 2233
// module chunks = 3